export default __webpack_public_path__ + "files/marker_monitoring_site-9e9714c865ce1bb5fd17c9bf5392ac11.png";